import { App, defineAsyncComponent } from 'vue';
import { vIntersectionObserver, vOnClickOutside } from '@vueuse/components';
import VueDatePicker from 'vue-datepicker-next';
import VueSlider from 'vue-slider-component'
import VueRouterPermission from '@/packages/vue-router-permissions'
import Vue3ColorPicker from "vue3-colorpicker"


import 'vue-datepicker-next/index.css';

export default {
  install(app: App<Element>): void {
    app
      .directive('on-click-outside', vOnClickOutside)
      .directive('intersection-observer', vIntersectionObserver)
    app
      // .component('VDropdown', Dropdown)
      .component('DatePicker', VueDatePicker)
      .component('VueSlider', VueSlider)
      .use(VueRouterPermission)
      .use(Vue3ColorPicker)
  },
}
